export const dataConfig = {
  // 国外焦炭 
  foreignCoke: {
    title: {
      name: "公司名称",
      prop: "companyName"
    },
    tableColumns: [
      { name: "品种", prop: "varieties", id: 111 },
      { name: "国别", prop: "country", id: 112 },
      { name: "洲", prop: "continent", id: 116 },
      { name: "地址", prop: "address", id: 113 },
      { name: "总产能", prop: "sumCapacity", unit: "万吨", id: 114 },
      { name: "是否钢焦联合", prop: "steelCokeUnion", id: 117 },
      { name: "备注", prop: "remark", id: 115 }
    ]
  },
  // 国内焦炭
  domesticCoke: {
    title: {
      name: "公司名称",
      prop: "companyName"
    },
    tableColumns: [
      { name: "品种", prop: "varieties", id: 1 },
      {
        name: "地址",
        row: [
          { name: "省", prop: "provinceName" },
          { name: "市", prop: "cityName" },
          { name: "", text: "<br>" },
          { name: "地址", prop: "address" },
        ],
        id: 3
      },
      { name: "企业性质", prop: "conpanyNature", id: 2 },
      { name: "企业类型", prop: "companyType", id: 6, 
        options:[
          { label: "我方", value: "1" },
          { label: "竞争对手", value: "2" }, 
        ]    
      },
      { name: "实际控制人", prop: "actualUser", id: 7 },
      { name: "总产能", prop: "sumCapacity", unit: '万吨', id: 4 },
      { name: "是否钢焦联合", prop: "steelCokeUnion", id: 8 },
      { name: "煤焦比", prop: "cokeRatio", id: 9 },
      { name: "焦场库存能力", prop: "cokeStockAbility", unit: '万吨', id: 10 },
      { name: "煤场库存能力", prop: "coalStockAbility", unit: '万吨', id: 11 },
      { name: "上下游配套产业", prop: "sxIndustry", id: 12 },
      { name: "其他产业", prop: "qtIndustry", id: 13 },
      { name: "备注", prop: "remark", id: 5 }
    ],
    otherColumns: [
      {
        id: 1111,
        name: "焦炭主要流向",
        columns: [
          { label: "区域", prop: "lxArea" },
          { label: "钢厂", prop: "lxSteelMill" },
          { label: "焦炭指标", prop: "lxCokeIndex" },
          { label: "供货量", prop: "lxSupplyVolume" },
        ]
      },
      {
        id: 1112,
        name: "物流情况",
        columns: [
          { label: "专用铁路", prop: "wlSpecialRailway" },
          { label: "站台名称", prop: "wlPlatformName" },
          { label: "是否专用", prop: "wlSpecialFlag" }
        ]
      },
      {
        id: 1113,
        name: "焦炉基本情况",
        prop: "cokeovenBasic",
        columns: [
          { label: "焦炉型号", prop: "type" },
          { label: "碳化室高度（米）", prop: "carbonizationChamberHeight", unit: "" },
          { label: "孔数", prop: "holeNum" },
          { label: "组数", prop: "groupNum" },
          { label: "产能（万吨）", prop: "capacity" },
          { label: "焦炉工艺", prop: "cokeOvenProcess" },
          { label: "熄焦工艺", prop: "cokeQuenchingProcess" },
        ]
      }
    ]
  },
  // 国外钢铁
  foreignSteel: {
    title: {
      name: "公司名称",
      prop: "factoryNameEn"
    },
    tableColumns: [
      { name: "品种", prop: "varieties", id: 121 },
      { name: "工厂别名", prop: "factoryNameAlias", id: 122 },
      { name: "国家（中文）", prop: "countryCn", id: 123 },
      { name: "国家（英文）", prop: "countryEn", id: 124 },
      { name: "洲", prop: "continent", id: 125 },
      { name: "工厂名称", prop: "factoryNameOrigin", unit: "所在国", id: 126 },
      { name: "位置", prop: "address", id: 127 },
      { name: "状态", prop: "status", id: 128 },
      { name: "自备焦炉", prop: "selfCokeoven", id: 129 },
      { name: "长短流程", prop: "processShortLong", id: 130 },
      { name: "设备类型", prop: "deviceType", id: 131 },
      { name: "设备详情", prop: "deviceInfo", id: 132 },
      { name: "粗钢总产量", prop: "steelLowSumOutput", id: 133 },
      { name: "BOF产量", prop: "bofOutput", id: 134 },
      { name: "EAF产量", prop: "eafOutput", id: 135 },
      { name: "生铁总产量", prop: "ironSumOutput", id: 136 },
      { name: "BF产量", prop: "bfOutput", id: 137 },
      { name: "DRI产量", prop: "driOutput", id: 138 },
      { name: "焦化产量", prop: "cokeOutput", id: 139 },
      { name: "成品产量", prop: "productOutput", id: 140 },
      { name: "粗钢总产能", prop: "steelLowSumCapacity", id: 141 },
      { name: "BOF产能", prop: "bofCapacity", id: 142 },
      { name: "EAF产能", prop: "eafCapacity", id: 143 },
      { name: "生铁总产能", prop: "ironSumCapacity", id: 144 },
      { name: "BF产能", prop: "bfCapacity", id: 145 },
      { name: "DRI产能", prop: "driCapacity", id: 146 },
      { name: "烧结产能", prop: "firingCapacity", id: 147 },
      { name: "球团产能", prop: "pelletizingCapacity", id: 148 },
      { name: "焦化产能", prop: "cokeCapacity", id: 149 },
      { name: "所有者", prop: "owner", id: 150 },
      { name: "母公司", prop: "parentCompany", id: 151 },
      { name: "备注", prop: "remark", id: 152 },
    ]
  },
  // 国内钢铁
  domesticSteel: {
    title: {
      name: "公司名称",
      prop: "companyName"
    },
    tableColumns: [
      { name: "品种", prop: "varieties", id: 11 },
      {
        name: "地址",
        row: [
          { name: "省", prop: "provinceName" },
          { name: "市", prop: "cityName" },
          { name: "", text: "<br>" },
          { name: "地址", prop: "address" },
        ],
        id: 13
      },
      { name: "企业性质", prop: "conpanyNature", id: 12 },
      { name: "实际控制人", prop: "actualUser", id: 14 },
      { name: "焦场容量", prop: "cokeCapacity", unit: '万吨', id: 15 },
      { name: "站台", prop: "platform", id: 16 },
      { name: "日卸车能力", prop: "dailyUnloading", id: 17 },
      { name: "焦炭月用量", prop: "monthlyCoke", unit: '万吨', id: 18 },
      { name: "备注", prop: "remark", id: 19 },
    ],
    otherColumns: [
      {
        id: 1111,
        name: "高炉",
        prop: "furnaces",
        columns: [
          { label: "高炉名称", prop: "furnaceName" },
          { label: "高炉容积", prop: "furnaceVolume", unit: "m³" },
          { label: "高炉产能", prop: "furnaceCapacity", unit: "万吨" },
          { label: "焦炭总需求", prop: "cokeDemand", unit: "万吨" },
          { label: "高炉配比", prop: "furnaceMatching" },
          { label: "高炉入炉比", prop: "furnaceCharging" },
        ]
      },
      {
        id: 1112,
        name: "炼钢",
        prop: "rollings",
        columns: [
          { label: "炼钢名称", prop: "steelmakingName" },
          { label: "炼钢容积", prop: "steelmakingVolume" },
          { label: "炼钢产能", prop: "steelmakingCapacity", unit: "万吨" },
        ]
      },
      {
        id: 1113,
        name: "轧钢",
        prop: "steelmakings",
        columns: [
          { label: "轧钢名称", prop: "rollingName" },
          { label: "轧钢产线数", prop: "rollingLine" },
          { label: "轧钢规格", prop: "rollingSpecification" },
          { label: "轧钢产能", prop: "rollingCapacity", unit: "万吨" },
        ]
      }
    ]
  },
  // 国外煤矿
  foreignCoal: {
    title: {
      name: "矿点名称",
      prop: "collieryName"
    },
    tableColumns: [
      { name: "洲", prop: "continent", id: 21 },
      { name: "国家", prop: "country", id: 22 },
      { name: "地址", prop: "address", id: 23 },
      { name: "类型", prop: "collieryType", id: 24 },
      { name: "状态", prop: "status", id: 25 },
      {
        name: "煤种",
        row: [
          { name: "煤种", prop: "coalKind" },
          { name: "", text: " / " },
          { name: "煤种(具体)", prop: "coalSpecificKind" }
        ],
        id: 26
      },
      { name: "起始年", prop: "startYear", id: 28 },
      { name: "终止年", prop: "endYear", id: 29 },
      { name: "近年产量低值", prop: "recentYearOutputHigh", unit: '万吨', id: 30 },
      { name: "近年产量高值", prop: "recentYearOutputLow", unit: '万吨', id: 31 },
      { name: "年产能", prop: "yearOutput", unit: '万吨', id: 32 },
      { name: "所有者", prop: "owner", id: 33 },
      { name: "运营商", prop: "operator", id: 34 },
      { name: "发起人", prop: "promoter", id: 35 },
      { name: "母公司", prop: "parentCompany", id: 36 },
      { name: "备注", prop: "remark", id: 37 }
    ]
  },
  // 国内煤矿
  domesticCoal: {
    title: {
      name: "矿点名称",
      prop: "collieryName"
    },
    tableColumns: [
      { name: "国家", prop: "country", id: 41 },
      {
        name: "地址",
        row: [
          { name: "省", prop: "provinceName" },
          { name: "市", prop: "cityName" },
          { name: "县", prop: "areaName" },
          { name: "地址", prop: "address" },
        ],
        id: 42
      },
      { name: "类型", prop: "collieryType", id: 43 },
      { name: "煤层", prop: "coalSeam", id: 44 },
      { name: "煤种", prop: "coalKind", id: 45 },
      { name: "供应商", prop: "supplier", id: 46 },
      { name: "年产能", prop: "yearOutput", unit: '万吨', id: 47 },
      { name: "运输方式", prop: "transportType", id: 48 },
      { name: "洗选方式", prop: "washingType", id: 49 },
      { name: "指标", prop: "index", id: 50 },
      { name: "备注", prop: "remark", id: 51 }
    ]
  },
  // 洗煤厂
  coalWashery: {
    title: {
      name: "洗煤厂",
      prop: "companyName"
    },
    tableColumns: [
      { name: "国家", prop: "country", id: 61 },
      {
        name: "地址",
        row: [
          { name: "省", prop: "provinceName" },
          { name: "市", prop: "cityName" },
          { name: "县", prop: "areaName" },
          { name: "地址", prop: "address" },
        ],
        id: 62
      },
      { name: "企业性质", prop: "enterpriseNature", id: 63 },
      { name: "煤种", prop: "coalKind", id: 64 },
      { name: "精煤/原煤", prop: "coalCleanRaw", id: 65 },
      { name: "指标", prop: "index", id: 66 },
      { name: "年产能", prop: "yearOutput", unit: '万吨', id: 67 },
      { name: "正常原煤日产量", prop: "coalRawDayOutput", unit: '万吨', id: 68 },
      { name: "正常精煤日产量", prop: "coalCleanDayOutput", unit: '万吨', id: 69 },
      { name: "正常原煤库存", prop: "coalRawStock", unit: '万吨', id: 70 },
      { name: "正常精煤库存", prop: "coalCleanStock", unit: '万吨', id: 71 },
      { name: "正常开工率", prop: "workRatio", id: 72 },
      { name: "备注", prop: "remark", id: 73 }
    ]
  },
  // 世界港口城市
  portCity: {
    title: {
      name: "港口代码",
      prop: "portCode"
    },
    tableColumns: [
      { name: "港口名称", prop: "cityName", text: " port", id: 81  },
      {
        name: "国家",
        row: [
          { name: "国家（中文）", prop: "countryCn" },
          { name: "", text: " （" },
          { name: "国家（英文）", prop: "countryEn" },
          { name: "", text: "）" },
        ],
        id: 82
      },
      { name: "地址", prop: "cityName", id: 83 },
      { name: "港口分类", prop: "portType", id: 84 },
      { name: "港口大小", prop: "portSize", id: 85 },
      { name: "港口说明", prop: "portInfo", id: 86 },
      { name: "管理单位", prop: "managementUnit", id: 87 },
      { name: "备注", prop: "remark", id: 88 }
    ]
  }
}

export const legendOptions = [
  { id: 1, name: '焦炭', bgColor: 'rgb(250, 154, 6)', icon: require("@/assets/map/mark_1.png") },
  { id: 2, name: '钢铁', alias: '钢厂', bgColor: 'rgb(3, 182, 236)', icon: require("@/assets/map/mark_2.png") },
  { id: 3, name: '煤矿点', bgColor: 'rgb(244, 227, 14)', icon: require("@/assets/map/mark_3.png") },
  { id: 4, name: '洗煤厂', bgColor: 'rgb(82, 55, 215)', icon: require("@/assets/map/mark_4.png") },
  { id: 5, name: '主要港口', bgColor: 'rgb(255, 133, 132)', icon: require("@/assets/map/mark_5.png") },
  { id: 6, name: '支线港口', bgColor: 'rgb(180, 189, 58)', icon: require("@/assets/map/mark_6.png") }
]

export const typeOptions = [
  { name: '国内焦炭', type: 12, prop: 'domesticCoke' },
  { name: '国外焦炭', type: 13, prop: 'foreignCoke' },
  { name: '国内钢厂', type: 14, prop: 'domesticSteel' },
  { name: '国外钢厂', type: 15, prop: 'foreignSteel' },
  { name: '洗煤厂', type: 7, prop: 'coalWashery' },
  { name: '国内煤矿点', type: 8, prop: 'domesticCoal' },
  { name: '国外煤矿点', type: 9, prop: 'foreignCoal' },
  { name: '主要港口', type: 10, prop: 'portCity' },
  { name: '支线港口', type: 11, prop: 'portCity' },
]